
import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { BListGroup, BListGroupItem } from 'bootstrap-vue';
import take from 'lodash/take';
import { VChart } from 'ah-reports';
import { makeBarChartOptions, makeBarChartDataset } from 'ah-reports';
import { TopAccountsCountReportChart } from 'ah-reports';
import { linesColorPrimary } from 'ah-reports';
import WithRequestManager from 'ah-common-lib/src/requestManager/WithRequestManager.vue';
import { useAuthStore } from '@/app/store/authModule';

const CURRENCY = 'GBP';
const TOP_DISPLAY_AMOUNT = 5;

@Component({
  components: {
    VChart,
    BListGroup,
    BListGroupItem,
    TopAccountsCountReportChart,
  },
})
export default class TopAccountsDashboardWidget extends Mixins(WithRequestManager) {
  @Prop({ required: true }) fromDate!: Date;

  @Prop({ required: true }) toDate!: Date;

  requestManagerConfig = {
    exposeToParent: true,
    onRetryFromParentManager: this.onRetryFromParentManager,
  };

  onRetryFromParentManager(k: string) {
    if (k === 'loadData') {
      this.loadDates();
    }
  }

  private options = makeBarChartOptions(
    { horizontal: true, gridColor: linesColorPrimary },
    {
      scales: {
        y: {
          ticks: {
            autoSkip: false,
          },
        },
      },
    }
  );

  private data = makeBarChartDataset();

  private accounts: Array<{ clientId: string; clientName: string; tradedAmount: number }> = [];

  private currency = CURRENCY;

  get dates() {
    return {
      from: this.fromDate,
      to: this.toDate,
    };
  }

  @Watch('dates', { immediate: true })
  loadDates() {
    this.requestManager
      .cancelAndNew('loadData', this.$services.trade.getClientTopAccountsReport(this.fromDate, this.toDate))
      .subscribe((response) => {
        this.accounts = take(response.list, TOP_DISPLAY_AMOUNT);
        this.data.datasets![0].data! = this.accounts.map((i) => i.tradedAmount);
        this.data.labels = this.accounts.map((i) => i.clientName);

        // Force update by replacing prop reference entirely
        this.options = { ...this.options };
        this.data = { ...this.data };
      });
  }

  get authStore() {
    return useAuthStore();
  }

  get loggedInUser() {
    return this.authStore.loggedInIdentity;
  }
}
